module.exports = __webpack_public_path__ + "img/banner-palate.45aedc47.png";